// extracted by mini-css-extract-plugin
export default {"angles_table":"AnglesTable_angles_table__aEXoP","accession_label":"AnglesTable_accession_label__u0+xu"};